import { FunctionComponent, useEffect, useState } from "react";
import styles from "./PublishPopupSingle.module.css";
import {
  CustomTextField,
  EditTicketType,
  InputPropsStyleForInvoice,
  checking,
  splitLocation,
} from "../../../helper";
import { Button } from "@mui/material";
import { useForm } from "react-hook-form";
import images from "../../../assets/images/index";
import ToasterWithMessage from "../toaster";

interface EditTicketPopUpProps {
  ticketData ?: EditTicketType;
  handleCloseDialog: () => void;
  handleAllow: any;
}

const InputField = CustomTextField();

const EditTicketPopUp: FunctionComponent<EditTicketPopUpProps> = ({
  ticketData,
  handleCloseDialog,
  handleAllow,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    setError,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: { section: "",row:"", seatno:"" },
    mode: "onTouched",
  });
  const [ticketSection, setSection] = useState<string>("");
  const [ticketRow, setRow] = useState<string>("");
  const [ticketSeatNo, setSeatNo] = useState<string>("");
  const [disableBtn,setDisableBtn] = useState<boolean>(true);
  const { CloseIcon } = images;

  const handleSubmitEdit = (formData:{section:string, row:string, seatno: string}) => {
      handleAllow(formData);
  };

  const handleResetEditData = () =>{
    if(ticketData){
    setValue("section", ticketData?.tp_section);
    setValue("row", ticketData?.tp_row);
    setValue("seatno", ticketData?.tp_seat_no?.toString());
    setSection(ticketData?.tp_section);
    setRow(ticketData?.tp_row);
    setSeatNo(ticketData?.tp_seat_no?.toString());
    setDisableBtn(true);
    }
  }

  const handleChangeSection = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const regexPattern = /^[a-zA-Z0-9 ]+$/;
    if (regexPattern.test(input) && input.trim() !== ""){
      setValue('section', input.toLowerCase());
      setSection(input.toLowerCase());
      trigger('section');
    } else {
      setValue('section',ticketSection)
      setSection(ticketSection);
    }
  };
  const handleChangeRow = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const regexPattern = /^[a-zA-Z0-9 ]+$/;
    if (regexPattern.test(input) && input.trim() !== ""){
        setValue('row',input.toLowerCase());
        setRow(input.toLowerCase());
        trigger('row');
    } else {
      setValue('row',ticketRow)
      setRow(ticketRow);
    }
  };

  const handleChangeSeatNo = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const regexPattern = /^[0-9 ]+$/;
    if (regexPattern.test(input) && input.trim() !== ""){
        setValue('seatno',input);
        setSeatNo(input);
        trigger('seatno');
    } else {
      setValue('seatno',ticketSeatNo)
      setSeatNo(ticketSeatNo);
    }
  };

  const handleKeyDown = (e :any) =>{
    if(e.key === 'Backspace'){
      if(ticketSection.length === 1){
        setSection("")
      }
    }
  }
  const handleRowKeyDown = (e :any) =>{
    if(e.key === 'Backspace'){
      if(ticketRow.length === 1){
        setRow("")
      }
    }
  }
  const handleSeatNoKeyDown = (e :any) =>{
    if(e.key === 'Backspace'){
      if(ticketSeatNo.length === 1){
        setSeatNo("")
      }
    }
  }
  const watchField = watch(['section', 'row', 'seatno']);

  useEffect(() => {
    if (ticketData) {
      setValue("section", ticketData?.tp_section);
      setValue("row", ticketData?.tp_row);
      setValue("seatno", ticketData?.tp_seat_no?.toString())
      setSection(ticketData?.tp_section);
      setRow(ticketData?.tp_row);
      setSeatNo(ticketData?.tp_seat_no?.toString())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketData]);

  useEffect(() => {
    const [section, row, seatno] = watchField;
    setDisableBtn(
      section.toLowerCase().trim() === String(ticketData?.tp_section).toLowerCase() &&
      row.toLowerCase().trim() === String(ticketData?.tp_row).toLowerCase() &&
      seatno.toLowerCase().trim() === String(ticketData?.tp_seat_no).toLowerCase()
    );
  }, [watchField, ticketData?.tp_section, ticketData?.tp_row, ticketData?.tp_seat_no]);

  return (
    <form onSubmit={handleSubmit(handleSubmitEdit)} autoComplete="off">
      <div className={styles.EditTicket}>
        <div className={styles.title}>
          <b className={styles.editTicketTitle}>Edit Ticket</b>
          <div className={styles.closeicon}>
            <img src={CloseIcon} alt="closeicon" onClick={handleCloseDialog} />
          </div>
        </div>
        <div className={styles.eventDetailsAndEditTicket}>
          <div className={styles.eventDetailsEditTicket}>
            <div className={styles.eventDetails1Edit}>Event Details</div>
            <div className={styles.eventDetails2Edit}>
              <div className={styles.eventEdit}>
                <b className={styles.date}>Event</b>
                <b className={styles.rocketsVsMemphisEdit}>{ticketData?.ticket?.event?.e_name ? ticketData?.ticket?.event?.e_name:"-"}</b>
              </div>
              <div className={styles.eventEdit}>
                <b className={styles.date}>Date</b>
                <b className={styles.rocketsVsMemphisEdit}>
                  {checking(ticketData?.ticket?.event?.e_date ? ticketData?.ticket?.event?.e_date:"-").date} /&nbsp;
                  {checking(ticketData?.ticket?.event?.e_date ? ticketData?.ticket?.event?.e_date:"-").time}
                </b>
              </div>
              <div className={styles.eventEdit}>
                <b className={styles.date}>Venue</b>
                <b className={styles.rocketsVsMemphisEdit}>
                  {splitLocation(ticketData?.ticket?.event?.e_address ? ticketData?.ticket?.event?.e_address:"-").firstWord}
                  {splitLocation(ticketData?.ticket?.event?.e_address ? ticketData?.ticket?.event?.e_address:"-").remainingWords}
                </b>
              </div>
              {/* <div className={styles.eventEdit}>
                <b className={styles.date}>Ticket Placement</b>
                <b className={styles.secA}>
                  Seat : {ticketData?.tp_seat_no ? ticketData?.tp_seat_no:"-"}
                </b>
              </div> */}
            </div>
          </div>
          <div className={styles.editTicketContainer}>
            {/* <div className={styles.eventDetails1Price}>Update Info</div> */}
            <div className={styles.bg}>
              <div className={styles.eventDetailsEditTicket}>
                <div className={styles.section}>
                <div className={styles.transactionId}>
                  <b className={styles.date}>Enter section</b>
                  <span className={styles.errorMsgSectionStyle}>
                        { errors?.section?.message}
                  </span>
                </div>
                  <div className={styles.textFieldSection}>
                    <div className={styles.container}>
                      <InputField
                        sx={{
                          "& input": {
                            height: "0.0375em",
                            textTransform:"capitalize"
                          },
                        }}
                        classes={{
                          root: styles.sectiondiv,
                        }}
                        {...register("section", {
                          required: "Section is required!",
                          pattern: {
                            value: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
                            message: 'Enter valid section'
                          },
                          maxLength: {
                            value: 32,
                            message: "Maximum of 32 characters",
                          },
                        })}
                        InputProps={{
                          style: InputPropsStyleForInvoice,
                        }}
                        placeholder={`Enter section`}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeSection(e)}
                        error={Boolean(errors?.section?.message)}
                        onKeyDown={handleKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.row}>
                <div className={styles.transactionId}>
                  <b className={styles.date}>Enter row</b>
                  <span className={styles.errorMsgRowStyle}>
                        { errors?.row?.message}
                  </span>
                </div>
                  <div className={styles.textFieldRow}>
                    <div className={styles.container}>
                      <InputField
                        sx={{
                          "& input": {
                            height: "0.0375em",
                            textTransform:"capitalize"
                          },
                        }}
                        classes={{
                          root: styles.rowdiv,
                        }}
                        {...register("row", {
                          required: "Row is required!",
                          pattern: {
                            value: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
                            message: 'Enter valid row'
                          },
                          maxLength: {
                            value: 32,
                            message: "Maximum of 32 characters",
                          },  
                          })}
                        // value={row}
                        InputProps={{
                          style: InputPropsStyleForInvoice,
                        }}
                        placeholder={`Enter row`}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeRow(e)}
                        error={Boolean(errors?.row?.message)}
                        onKeyDown={handleRowKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.seatno}>
                <div className={styles.transactionId}>
                  <b className={styles.date}>Enter seat no</b>
                  <span className={styles.errorMsgRowStyle}>
                        { errors?.seatno?.message}
                  </span>
                </div>
                  <div className={styles.textFieldSeatno}>
                    <div className={styles.container}>
                      <InputField
                        sx={{
                          "& input": {
                            height: "0.0375em",
                            textTransform:"capitalize"
                          },
                        }}
                        classes={{
                          root: styles.seatnodiv,
                        }}
                        {...register("seatno", {
                          required: "Seat no is required!",
                          pattern: {
                            value: /^[0-9]+(?: [0-9]+)*$/,
                            message: 'Enter valid seat no'
                          },
                          maxLength: {
                            value: 32,
                            message: "Maximum of 32 digits are allowed",
                          },  
                          })}
                        // value={row}
                        InputProps={{
                          style: InputPropsStyleForInvoice,
                        }}
                        placeholder={`Enter seat no`}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeSeatNo(e)}
                        error={Boolean(errors?.row?.message)}
                        onKeyDown={handleSeatNoKeyDown}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cta}>
          <div className={styles.buttons} onClick={handleResetEditData}>
            <Button
              classes={{ root: styles.separateStyleforcancel }}
              fullWidth
              disableRipple
            >
              Reset
            </Button>
          </div>
          <div className={disableBtn?styles.disabledButton:styles.buttons1}>
            <Button
              classes={{ root: disableBtn 
                ? styles.separateStyledisabledUpdateBtn
                : styles.separateStyle }}
              disableRipple
              fullWidth
              type="submit"
              disabled={disableBtn}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default EditTicketPopUp;
